<template>
  <div
    v-if="!is360Overview || !isModal"
    class="photo-slider__items"
    :class="{ 'is-modal': isModal, 'photo-slider__items--review-modal': isCommentGallery }"
  >
    <div class="carousel">
      <div class="carousel__body">
        <div class="swiper-block-container" @click="openPhotoModal(isModal)">
          <swiper
            class="swiper"
            :class="{ 'no-swipe': !isModal }"
            :options="isCommentGallery ? swiperOptionReviewMediaModal : isModal ? swiperOptionModal : swiperOption"
            ref="swiper"
          >
            <swiper-slide
              class="swiper-item"
              :class="{ 'video-slider-item': item.video_id }"
              v-for="(item, i) in photosForRender"
              :key="i"
            >
              <div class="swiper-item__container">
                <div class="swiper-item__item">
                  <div v-if="item.video_id" class="video-slider-item__player">
                    <MainVideo
                      :currentVideoIdx="i"
                      :video-id="item.video_id"
                      :is-active="i === currentPhotoIndex"
                    />
                    <!--                    <script v-html="json_ld_video(item.video_id)" type="application/ld+json"></script>-->
                  </div>
                  <div v-else class="img-container">
                    <img
                      :src="item.origin_photo"
                      loading="lazy"
                      class="swiper-lazy"
                      :class="{ 'swiper-lazy--modal': isModal }"
                      alt="alt"
                    />
                    <Loader is-loading />
                    <!--                    <script v-html="json_ld_image(item)" type="application/ld+json"></script>-->
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div v-if="isModal" class="swiper-button-next" slot="button-next"></div>
          <div v-if="isModal" class="swiper-button-prev" slot="button-prev"></div>
        </div>
        <div class="pagination-wrap">
          <div v-if="!isModal || isCommentGallery" class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="overview-wrapper" v-else>
    <Overview />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Loader from '../../../helpers/Loader'
import { isAdaptiveMode } from '@/mixins'
import Overview from '../Overview'
import MainVideo from '../video-gallery/MainVideo'

export default {
  name: 'PhotoSlider',
  mixins: [isAdaptiveMode],
  props: {
    isModal: {
      type: Boolean,
      default: false
    },
    photos: {
      type: Array
    },
    videos: {
      type: Array
    },
    shortPhotoList: {
      type: Array
    },
    currentPhotoIndex: {
      type: Number,
      default: 0
    },
    initialSlide: {
      type: Number,
      default: 0
    },
    is360Overview: {
      type: Boolean
    },
    isCommentGallery: {
      type: Boolean,
      default: false
    },
    media: {
      type: Array
    },
    isQuestions: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MainVideo,
    Overview,
    Loader,
    Swiper,
    SwiperSlide
  },
  computed: {
    ...mapGetters(['initSlideIndex']),
    ...mapState({
      productTitle: state => state.productInfo.productInfo.title
    }),
    photosForRender () {
      return this.media ? this.media : [...this.photos, ...this.videos]
    }
  },
  methods: {
    ...mapActions(['CHANGE_MAIN_PHOTO_INDEX']),
    ...mapActions('comments', ['CHANGE_CURRENT_MEDIA_INDEX']),
    ...mapActions('questions', ['CHANGE_CURRENT_MEDIA_QUESTIONS_INDEX']),
    // json_ld_image (item) {
    //   return {
    //     '@context': 'https://schema.org',
    //     '@type': 'ImageObject',
    //     'url': item.origin_photo,
    //     'description': this.productTitle + ' image',
    //     'name': this.productTitle
    //   }
    // },
    // json_ld_video (videoId) {
    //   return {
    //     '@context': 'https://schema.org/',
    //     '@type': 'VideoObject',
    //     'name': 'Video about product',
    //     'description': 'Video about product',
    //     'thumbnailUrl': `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
    //     'contentUrl': `https://www.youtube.com/embed/${videoId}?rel=0&amp&enablejsapi=1;showinfo=0&amp;autoplay=1`,
    //     'embedUrl': `https://www.youtube.com/embed/${videoId}?rel=0&amp&enablejsapi=1;showinfo=0&amp;autoplay=1`
    //   }
    // },
    goToSlide (index) {
      this.$nextTick(() => {
        this.$refs.swiper.$swiper.slideTo(index)
        this.$refs.swiper.$swiper.update()
      })
    },
    openPhotoModal (bool) {
      if (!bool) {
        this.$modal.show('photo-modal')
      }
    }
  },
  data () {
    return {
      swiperOption: {
        spaceBetween: 10,
        navigation: false,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        slidesPerView: 'auto',
        preloadImages: false,
        lazy: true,
        initialSlide: this.initialSlide
      },
      swiperOptionModal: {
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 'auto',
        preloadImages: false,
        lazy: true,
        initialSlide: this.currentPhotoIndex
      },
      swiperOptionReviewMediaModal: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        lazy: {
          loadPrevNext: true
        },
        preloadImages: false,
        initialSlide: this.currentPhotoIndex
      }
    }
  },
  mounted () {
    // хак для того чтобы в модалке swiper инициализировал правильную ширину слайда
    setTimeout(() => window.dispatchEvent(new Event('resize')), 0)
    this.$nextTick(() => {
      if (this.isCommentGallery) {
        if (this.isQuestions) {
          this.CHANGE_CURRENT_MEDIA_QUESTIONS_INDEX(this.currentPhotoIndex)
        } else {
          this.CHANGE_CURRENT_MEDIA_INDEX(this.currentPhotoIndex)
        }
      } else if (!this.isModal) {
        this.CHANGE_MAIN_PHOTO_INDEX(this.initialSlide)
      }

      if (!this.$refs.swiper) return
      const swiper = this.$refs.swiper.$swiper

      // Cобытие изменения слайда, при котором индекс слайда записывается в стор
      swiper.on('slideChange', () => {
        if (this.isCommentGallery) {
          if (this.isQuestions) {
            this.CHANGE_CURRENT_MEDIA_QUESTIONS_INDEX(swiper.realIndex)
          } else {
            this.CHANGE_CURRENT_MEDIA_INDEX(swiper.realIndex)
          }
        } else {
          this.CHANGE_MAIN_PHOTO_INDEX(swiper.realIndex)
        }
      })
    })
  },
  beforeDestroy () {
    if (this.currentPhotoIndex > 4 && !this.isCommentGallery) {
      // Возвращается в к первому слайдеру, если при закрытии модалки был выбран слайд которого нету в галереи на самой странице
      this.CHANGE_MAIN_PHOTO_INDEX(this.initSlideIndex)
    }
  },
  watch: {
    currentPhotoIndex (value) {
      if (!this.isCommentGallery) {
        this.goToSlide(value)
      }
    },
    is360Overview (value) {
      if (!value) {
        this.$nextTick(() => {
          const swiper = this.$refs.swiper.$swiper
          // Вешает событие изменения слайдера при переходе с обзора 360 на слайдер
          swiper.on('slideChange', () => {
            this.CHANGE_MAIN_PHOTO_INDEX(swiper.realIndex)
          })
          this.goToSlide(this.currentPhotoIndex)
        })
      }
    }
  }
}
</script>

<style scoped lang="sass">

@import "../../../../styles/swiper/swiper"

.swiper-block-container
  position: relative

.is-modal.photo-slider__items
  margin: 15px 0

.photo-slider__items
  width: 100%
  position: relative
  cursor: pointer

.photo-slider__navigation
  width: 100%
  position: absolute
  top: 50%
  transform: translateY(-50%)
  z-index: 2

.swiper-item__item
  width: 100%
  height: 100%

.img-container
  display: flex
  align-items: center
  justify-content: center
  height: 100%
  padding: 1px
  position: relative

.img-container img
  cursor: pointer

.swiper-lazy
  width: 100%

  &.swiper-lazy--modal
    max-height: 100%
    object-fit: contain

.swiper-lazy-loaded
  width: auto

.no-swipe
  +mmin($tablet)
    touch-action: none
    pointer-events: none
    cursor: pointer

.swiper-lazy-loaded + .loader-filter
  display: none

.pagination-wrap
  position: relative
  width: 70px
  height: 10px
  margin: 30px auto 0
  overflow: hidden

  +mmin($tablet--hor)
    display: none

+mmin($tablet)
  .photo-slider__items:not(.is-modal) .pagination-wrap
    display: none

.swiper-pagination ::v-deep
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  z-index: 2
  white-space: nowrap

  .swiper-pagination-bullet
    background-color: $nd-label-color
    margin: 0 3px
    transform: scale(0.5)

  .swiper-pagination-bullet-active-prev,
  .swiper-pagination-bullet-active-next
    transform: scale(0.75)

  .swiper-pagination-bullet-active-main
    background-color: $main-color
    transform: scale(1)

  +mmin($tablet)
    display: none

.overview-wrapper
  display: flex
  justify-content: center
  padding-left: 10px

.is-modal
  .video-slider-item
    display: flex
    align-items: center
    justify-content: center

  .swiper-button-prev,
  .swiper-button-next
    +mmax(1023)
      display: none

.photo-slider__items
  width: 100%
  height: 100%
  max-height: 100%
  margin: 0

  .swiper-item__container
    position: relative
    width: 100%
    max-width: 690px
    padding-bottom: min(690px, 100%)
    overflow: hidden
    margin: 0 auto

  .swiper-item__item
    width: 100%
    height: 100%
    object-fit: contain
    position: absolute
    top: 0
    left: 0

  .video-slider-item__player
    position: relative
    width: 100%
    top: 50%
    transform: translateY(-50%)
    margin: 0 auto

  &:not(.photo-slider__items--review-modal) .video-slider-item__player
    width: 80%
    max-width: 90vh
    +mmax(1100)
      width: 90%

  .swiper-lazy
    width: 100%
    height: 100%

  .swiper-pagination ::v-deep
    display: block

    +mmin($tablet--hor)
      display: none

.swiper
  display: flex
  align-items: center

.carousel
  height: 100%

.carousel__body ::v-deep
  position: relative

.carousel__body, .swiper-block-container, .swiper
  height: inherit
</style>
